import React, { useEffect, useState } from 'react'
import { ListResponseType, NotificationListItem, ResponseType, VisaItemType } from '../../../../types'
import { useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import CustomInput from '../../../UI/customInput/customInput'
import { VisaStatus } from '../../../VisaStatus/VisaStatus'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../../UI/customButton/customButton.js'
import { ArrowDown, ChevronDown, UsersIcon } from '../../../../icons/icons.js'
import { CrowTable } from './CrowTable'
import FormNumberThree from '../../../../pages/visa-orders/forms/formNumberThree.js'
import { useMutation } from 'react-query'
import { Get, Post } from '../../../../apis/api.js'
import { toast } from 'react-toastify'
import Loading from '../../../Loading/index.jsx'
import clsx from 'clsx'
import { CancelVisas } from './CancelVisas'
import { ExtendVisa } from './ExtendVisa'
import { Link } from 'react-router-dom'
import { DeleteVisa } from 'src/components/visaActions/DeleteVisa'
import { useNotifications, useReadNotif } from 'src/hooks'
import FormNumberTwo from '../../../../pages/visa-orders/forms/formNumberTwo'
import { CompleteVisa } from 'src/components/visaActions/CompleteVisa'

export const Row = (record: VisaItemType & { onSuccessMutate: Function, nationality: Array<{ id: string, en_name: string, fa_name: string }> }) => {

  const { subject, status, automation_number, created_at, agent, id, visa, crews, onSuccessMutate, letter_number, command_letter_number, command_letter_file, otb_file, nationality } = record

  // const [pdf, setPdf] = useState<Blob | undefined>()



  const [processLoading, setProcessLoading] = useState<boolean>(false)

  const [atNumber, setAtNumber] = useState<string | undefined>(automation_number ?? undefined)

  const [commandNumber, setCommandNumber] = useState<string | undefined>(command_letter_number ?? undefined)


  const [selectedCrews, setSelectedCrews] = useState<{ persons: string[] }>({ persons: [] })


  const user = useSelector((state) => (state as any).user.user)

  const isAgent = user?.role_key === "agent"

  const isAdmin = user?.role_key === "super_admin"


  const { data, isLoading: loadingNotifs, refetch } = useNotifications(1, 10, isAdmin)

  const { mutate: mutateReadingNotif, data: notifReadData } = useReadNotif()

  const notifList = (data as unknown as ListResponseType<NotificationListItem>)?.details?.data?.data ?? []

  const visaNotif = notifList?.find(i => (JSON.parse(i.variables) as unknown as Array<string>)[0] == id.toString())

  const isNew = visaNotif?.read == 0


  const [isOpen, setIsOpen] = useState<boolean>(false)


  const lng = useSelector((state) => (state as any).common.lng)

  const { t } = useTranslation();

  const [isSelected, setSelected] = useState<boolean>(false)

  const [createCommandPDF, setCreateCommandPDF] = useState<(() => Promise<Blob>) | undefined>(undefined)
  const [createOKTBPDF, setCreateOKTBPDF] = useState<(() => Promise<Blob>) | undefined>(undefined)


  const sendCommandLetter = async () => {

    if (!createCommandPDF)
      return Promise.reject()

    const commandPDF = await createCommandPDF()
    const formData = new FormData()

    formData.append('form', "command_letter_from")
    formData.append('command_letter_number', (commandNumber ?? '')?.toString())


    if (commandPDF) {
      formData.append('command_letter_file', commandPDF, 'command-doc.pdf')
    }


    return Post(`/admin/visas/send-command-letter/${id}`, formData)

  }


  const saveAutomation = () => {

    if (!atNumber) {

      return Promise.reject()
    }
    return Post(`/admin/visas/save-automation/${id}`, {
      form: "admin_automation_number",
      automation_number: atNumber
    })
  }


  const sendOTB = async () => {

    const formData = new FormData();

    if (!createCommandPDF) {
      alert('The OKTB Letter is Not Ready')
      return Promise.reject
    }
    else {

      const oktbPDF = createOKTBPDF ? await createOKTBPDF() : undefined
      if (!oktbPDF) {
        alert('The OKTB Letter is Not Ready')
        return Promise.reject()
      }

      if (!atNumber) {
        alert('Automation Number is Not Entered!')
        return Promise.reject()
      }
      formData.append("form", "otb_from");
      formData.append("subject", "OK TO BOARD");
      formData.append("otb_file", oktbPDF, 'my-document.pdf');
      formData.append("automation_number", atNumber)
      formData.append("email_body", "OK TO BOARD")


    }
    return Post(`/admin/visas/send-otb/${id}`, formData)
  }



  const { mutate: mutateAll, isLoading: loadingCommnad } = useMutation({
    mutationFn: () => {
      setProcessLoading(true)
      if (visa?.need_otb) {  //If No Need For Resending OKTB => && !otb_file
        return Promise.all([sendOTB(), ...(!command_letter_number ?  [sendCommandLetter()] : [])])
      }

      else return Promise.all([saveAutomation(), ...(!command_letter_number ?  [sendCommandLetter()] : [])])
    },

    mutationKey: ['MutateAll', id],
    onSuccess: (res: Array<any>) => {

      if (Array.isArray(res))
        res?.forEach(f => toast.success(f?.msg))

      onSuccessMutate()

    },
    onError: (error: any) => {
      if (Array.isArray(error))
        error?.forEach(error => toast.error(error?.data?.message || error?.data?.msg))
      else {
        toast.error(error?.data?.message || error?.data?.msg)
      }

    },
    onSettled: () => {
      setProcessLoading(false)
    }
    // })

  })
  useEffect(() => {
    if (notifReadData) {
      refetch()
    }
  }, [notifReadData])

  useEffect(() => {
    if (isOpen && isNew)
      mutateReadingNotif({ id: visaNotif.id } as any)
  }, [isOpen])





  const handleSaving = () => {
    if (!atNumber) {
      return toast.info(t('automationNumberIsNotEntered'))
    }

    if (!commandNumber)
      return toast.success(t('CommandNumberIsNotEntered'))

    setProcessLoading(true)

    mutateAll()


  }

console.log({processLoading , loadingCommnad})
  const isLoadingProccess = processLoading || loadingCommnad

  const commandTitle = "فرماندهی محترم نیروی انتظامی (اتباع خارجی)"

  return (
    <div className={clsx('border  border-gray-500 rounded-xl  flex flex-col items-stretch  gap-2 mx-4 p-2 overflow-hidden  transition-all duration-500', isNew ? 'border-r-primary-300 border-primary-300 border-r-4' : 'border-b border-gray-400  ')}>

      <FormNumberThree
        id={id}
        onPdf={(e: Blob) => { }}
        setLoading={(state: boolean) => setProcessLoading(state)}
        atNumber={atNumber}
        createPDFasync={createOKTBPDF}
        setCreatePDFasync={setCreateOKTBPDF}

      />

      <FormNumberTwo
        activeStep={undefined}
        defaultId={id}

        atNumber={atNumber}

        createPDFasync={createCommandPDF}
        setCreatePDFasync={setCreateCommandPDF}

        defaultLetterNumber={commandNumber}
        defaultEmails={[{ title: commandTitle }]}

        mode='pdf'


      />
      <div key={id} className={`b g-white grid  items-center w -full  cursor-pointer z-10  ${isAgent ? 'grid-cols-7' : 'grid-cols-8'}`} onClick={() => setIsOpen(s => !s)}>



        <div className="p-3 text-center col-span-1 flex flex-row justify-center gap-2">
          <div className={"text-gray-700 text-sm mt-1 relative"}>
            {id}
            {isNew && <span className='bg-red text-white rounded-2xl text-sm absolute left-full translate-x-2 p-1 -translate-y-1/2 top-1/2'>{t('new')}</span>}
          </div>
        </div>
        {/*<div className="p-3 text-center">*/}
        {/*  <div className={"text-gray-700 text-sm mt-1"}>*/}
        {/*    {item?.crew?.nationality}*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="p-3 text-center col-span-1">
          <div className={"text-gray-700 text-sm mt-1"}>
            {(visa as any)?.[`${lng}_name`]}
          </div>
        </div>
        {!isAgent && <div className="p-3 text-center col-span-1">
          <div className={"text-gray-700 text-sm mt-1"}>
            {(agent?.name ?? '-') + " " + (agent?.last_name ?? '-')}
          </div>
        </div>}
        <div className="p-3 text-center col-span-1">
          <div className={"text-gray-700 text-sm mt-1"}>
            {created_at && moment(created_at).format(lng === "en" ? "YYYY/MM/DD" : "jYYYY/jMM/jDD")}
          </div>
        </div>



        <div className=" py-4 text-start text-gray-700 text-sm font-medium col-span-1">
          <div className={"mt-1 flex justify-center"}>
            <VisaStatus status={status} />
          </div>
        </div>
        {/*<div className=" py-4  text-start text-gray-700 text-sm font-medium col-span-1">
          {
            
            <div className={"flex justify-center" }>
              <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
                {!(status === 0 || status === 1) ? <FormIconPure/> : <FormIcon/>}
              </div>
            </div>
          }

        </div> */}
        {/* <div className={clsx("p-3 text-center col-span-1 flex flex-row gap-2 items-center ")}>

        </div> */}
        <div className={clsx("p-3 text-center col-span-3 flex-1 flex flex-row gap-2 items-center ", isAgent ? 'justify-between' : 'justify-end')}>
          {
            (user?.role_key === "agent" ) ? /// || !!automation_number Renders When User Is Agent
              <div className={"text-gray-700 text-sm mt-1 flex-1 text-center "}>
                <div className={"flex gap-2 justify-center"}>
                  <span> {command_letter_number ?? '-'} / {automation_number ?? '-'} </span>
                </div>
              </div>
              :
              ((letter_number) ? 
                <div className={"text-gray-700 text-sm mt-1"}>
                  <div className={"flex gap-2.5 justify-end items-center"}>
                    <span className={"w-[1 0px] min-w-20 flex-1"}>
                      {!!visa?.need_command_letter && <CustomInput
                        placeHolder={t("CommandLetterNumber")}
                        label={t("CommandLetterNumber")}
                        name={"CommandLetter" + id}
                        onchange={(e: any) => setCommandNumber(e?.value)}
                        defaultValue={commandNumber}
                        disable={isLoadingProccess || !!command_letter_number}
                        maxLength={10}
                      // className={'text-sm'}
                      />}
                    </span>


                    <span>/</span>
                    <span className={"w-[12 0px] min-w-20 flex-1"}>
                      <CustomInput
                        placeHolder={t("automationNumber")}
                        label={t("automationNumber")}
                        name={"automationNumber" + id}
                        onchange={(e: any) => setAtNumber(e?.value)}
                        defaultValue={atNumber}
                        disable={isLoadingProccess}
                        maxLength={10}
                      />
                    </span>

                    <div className={"w-[8 0px]"} onClick={(e) => e.stopPropagation()}>
                      {/* <button onClick={handleFakeGet}>sdfsdf</button> */}
                      {isLoadingProccess
                        ? <div className='flex flex-row flex-1 justify-center items-center h-full'><Loading /></div>
                        : <button
                          onClick={handleSaving}
                          className='bg-primary-300 text-white px-3 py-3 rounded-lg'>{t("save")}</button>
                      }
                    </div>
                  </div>
                </div> : <span className='text-center text-gray-700 text-sm'>{t('WaitForNationalityOfficeLetter')}</span>)
          }

          <ChevronDown className={`transition-all duration-300 size-4 text-gray-700 shrink-0 ${isOpen ? '-rotate-180' : ''}`} />
        </div>
      </div>


      <div className={`flex flex-col gap-4 items-center transition -all duration- 300 w-full relative  ${isOpen ? 'translate-y-0 max-h-[1000px] opacity-100' : '-translate-y-full opacity-0 max-h-0 -mt-2'}`}>

        <div className='bg-gray-100 w-full h-[1px]'> </div>
        <div className='flex flex-row gap-2 justify-between w-full px-6'>
          <div className='flex flex-row gap-2 items-center text-gray-800 text-sm'>
            <UsersIcon className='size-5' />
            <span className=''>{t('crews')}</span>
          </div>
          <div className='flex flex-row gap-2'>

            {!!letter_number && isAdmin && <Link to={`/visa-orders/forms/${id}`}
              className='bg-purple-100 text-purple-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
              title={`${t('View')} ${t('NationalityOfficeLetter')}`}
            >
              {t('View')} {t('NationalityOfficeLetter')}
            </Link>}


            {isAgent && <div className='flex flex-row gap-2 items-center'>
              {status == 0 && < DeleteVisa visaId={id.toString()} onSuccessMutate={onSuccessMutate} />}

              <CancelVisas onSuccessMutate={onSuccessMutate} agentVisaId={crews?.[0]?.agent_visa_id} crows={crews.filter(i => selectedCrews.persons.indexOf(i.crew_id) != -1)} />

              {!!visa?.residence && <ExtendVisa onSuccessMutate={onSuccessMutate} duplicate_visa_id={crews?.[0]?.agent_visa_id} crewsData={crews.filter(i => selectedCrews.persons.indexOf(i.crew_id) != -1).map(i => ({ id: i.crew_id, job_id: i.job_id }))} />}

              {isAgent && status == 0 && <Link to={`/pay-visa?visaId=${id}`} title={t('Pay')}>            <button
                className='bg-green-100 text-green-200  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={t('Pay')}

              >
                {t('Pay')}
              </button></Link>}



            </div>}

            {isAdmin && !letter_number && (status == 1) && <Link to={`/visa-orders/forms/${id}`}
              className='bg-green-100 text-green-200  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
              title={`${t('Send')} ${t('NationalityOfficeLetter')}`}
            >
              {t('Send')} {t('NationalityOfficeLetter')}
            </Link>}


            {!!command_letter_file && <button onClick={() => window.open(`https://api.flysepehr.com/storage${command_letter_file}`)}
              className='bg-amber-100 text-amber-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
              title={`${t('ViewCommandLetter')}`}
            >
              {t('ViewCommandLetter')}
            </button>}

            {!!otb_file && <button onClick={() => window.open(`https://api.flysepehr.com/storage${otb_file}`)}
              className='bg-teal-100 text-teal-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
              title={`${t('View')} OKTB`}
            >
              {t('View')} OKTB
            </button>}

            {!!command_letter_number && status != 15 && <CompleteVisa visaId={id.toString()} onSuccessMutate={onSuccessMutate} />}


          </div>
        </div>

        <CrowTable
          crews={crews.map(i => ({ ...i, nationEN: nationality.find(n => n.id == i.crew.nationality)?.en_name ,  nationFA: nationality.find(n => n.id == i.crew.nationality)?.fa_name}))}
          visaStatus={status}
          selectedCrews={selectedCrews.persons}
          onSelectCrews={(items) => setSelectedCrews({ persons: items })}
        />

      </div>

    </div>


  )
}
